export { default } from './DataCentre';



// WEBPACK FOOTER //
// ./src/pages/Students/DataCentre/index.ts